

let NumberFormatter = {
    formatFloat: function(number, decimals, append) {
        let formatted = isNaN(number) ? 0 : number.toFixed(decimals || 2).toString().replace(".", ",");

        if (append) {
            formatted += append;
        }
        return formatted;
    },

    formatMoney: function(amount, append) {
        if (isNaN(amount)) {
            return '';
        }

        let formatted = amount.toFixed(2).toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');

        if (append) {
            formatted += append;
        }
        return formatted;
    }
};

window.NumberFormatter = NumberFormatter;

/**
 * Parse un nombre décimal dans un champ
 */
$.fn.parseFloat = function() {
    let value = this.is('input, select') ? this.val() : this.text();

    if (undefined === value) {
        return undefined;
    }

    return parseFloat(value.replace(',', '.'))
};

/**
 * Formatte un nombre flottant dans un champ texte
 *
 * Le nombre de décimales est paramétrable, et a comme défaut 2
 */
$.fn.formatFloat = function(number, decimals) {
    let formatted = NumberFormatter.formatFloat(number, decimals);

    if (this.is('input')) {
        this.val(formatted)
    } else {
        this.text(formatted)
    }
};

/**
 * Parse un nombre entier dans un champ
 */
$.fn.parseInt = function() {
    let value = this.is('input') ? this.val() : this.text();

    if (undefined === value) {
        return undefined;
    }

    return parseInt(value)
};

/**
 * Formatte un montant et inscrit sa valeur dans le champ courant.
 *
 * Le nombre de décimales est paramétrable est a comme défaut 2
 *
 * Les chiffres sont séparés par un espace tous les milliers.
 */
$.fn.formatMoney = function(amount, append) {
    let formatted = NumberFormatter.formatMoney(amount, append);

    if (this.is('input')) {
        this.val(formatted)
    } else {
        this.text(formatted)
    }
};

/**
 * Parse le montant d'un champ monnaie en nombre flottant
 */
$.fn.parseMoney = function() {
    let value = this.is('input') ? this.val() : this.text();

    return parseFloat(value.replace(/ /g, '').replace(',', '.'))
};


// WEBPACK FOOTER //
// ./js/form/form.js